import { useEffect, useState } from "react";
import { clientById } from "@apis";
import { useRouterStore } from "@stores";

// Logo del cliente/radio activo, para usarlo en el header de los informes en PDF.
export const useClientLogo = (): string | undefined => {
  const clientId = useRouterStore((state) => state.clientId);
  const [logo, setLogo] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!clientId) {
      setLogo(undefined);
      return;
    }
    let cancelled = false;
    clientById(String(clientId))
      .then(({ data }) => {
        if (!cancelled) setLogo(data?.logo || undefined);
      })
      .catch(() => {
        if (!cancelled) setLogo(undefined);
      });
    return () => {
      cancelled = true;
    };
  }, [clientId]);

  return logo;
};
